(() => {
  const mq = window.matchMedia('(min-width: 901px)');

  const getRoot = () => document.getElementById('modoease-pro-buy');

  const getState = () => {
    const root = getRoot();
    if (!root) return null;
    const shell = root.querySelector('.modoease-pro__gallery-shell');
    const gallery = shell?.querySelector('[data-pro-gallery]');
    const slides = gallery ? [...gallery.querySelectorAll('[data-pro-slide]')] : [];
    if (!shell || !gallery || slides.length < 2) return null;
    return { shell, gallery, slides };
  };

  const nearestIndex = (gallery, slides) => {
    const center = gallery.scrollLeft + gallery.clientWidth / 2;
    let index = 0;
    let distance = Infinity;
    slides.forEach((slide, i) => {
      const d = Math.abs((slide.offsetLeft + slide.offsetWidth / 2) - center);
      if (d < distance) {
        distance = d;
        index = i;
      }
    });
    return index;
  };

  const setActive = (shell, index) => {
    shell.querySelectorAll('[data-pro-desktop-thumb]').forEach((thumb, i) => {
      const active = i === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
      if (active) thumb.scrollIntoView({block:'nearest', inline:'nearest'});
    });
  };

  const build = () => {
    if (!mq.matches) return;
    const state = getState();
    if (!state) return;
    const { shell, gallery, slides } = state;
    if (shell.querySelector('[data-pro-desktop-thumbs]')) return;

    const rail = document.createElement('div');
    rail.className = 'modoease-pro__desktop-thumbs';
    rail.setAttribute('data-pro-desktop-thumbs', '');
    rail.setAttribute('aria-label', 'Product image thumbnails');

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    slides.forEach((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'modoease-pro__desktop-thumb';
      button.setAttribute('data-pro-desktop-thumb', '');
      button.setAttribute('aria-label', `View product image ${index + 1}`);
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      if (index === 0) button.classList.add('is-active');

      const sourceImage = slide.querySelector('img');
      const sourceVideo = slide.querySelector('video');

      if (sourceImage) {
        const img = document.createElement('img');
        img.src = sourceImage.currentSrc || sourceImage.src;
        img.alt = sourceImage.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        button.appendChild(img);
      } else if (sourceVideo?.poster) {
        const img = document.createElement('img');
        img.src = sourceVideo.poster;
        img.alt = '';
        img.loading = 'lazy';
        button.appendChild(img);
      } else {
        const label = document.createElement('span');
        label.textContent = `View ${index + 1}`;
        button.appendChild(label);
      }

      button.addEventListener('click', () => {
        gallery.scrollTo({
          left: slides[index].offsetLeft,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
        setActive(shell, index);
      });

      rail.appendChild(button);
    });

    shell.prepend(rail);
    setActive(shell, nearestIndex(gallery, slides));

    if (!gallery.dataset.desktopThumbSync) {
      gallery.dataset.desktopThumbSync = 'true';
      let ticking = false;
      gallery.addEventListener('scroll', () => {
        if (!mq.matches || ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const current = getState();
          if (current) setActive(current.shell, nearestIndex(current.gallery, current.slides));
          ticking = false;
        });
      }, {passive:true});
    }
  };

  const destroy = () => {
    getRoot()?.querySelector('[data-pro-desktop-thumbs]')?.remove();
  };

  const sync = () => {
    if (mq.matches) build();
    else destroy();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, {once:true});
  } else {
    sync();
  }

  mq.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();